export class AzureKeyVaultKey {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keyUri",
            "baseName": "keyUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "keyName",
            "baseName": "keyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureKeyVaultKey.attributeTypeMap;
    }
    constructor() {
    }
}
